import { makeStyles } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import DashboardLayout, { DashboardPage } from '../layout'
import { PlusOutlined } from '@ant-design/icons'
import { useData } from '../../../data'
import { trackPromise, usePromiseTracker } from 'react-promise-tracker'
import UploadsTableView from './table_view'
import AddNewUpload from './new_upload'
import { useRouter } from '../../../routes'
import { notification} from 'antd'

const useStyles = makeStyles(theme => ({
    content: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'start',
        height: '100%',
        paddingTop: theme.spacing(3)
    }
}))

/**
 * Uploads Dashboard page
 */
const Uploads = (props) => {
    const router = useRouter()
    const [currentPage, setCurrentPage] = useState(router.query?.page ? parseInt(router.query?.page) : 1)
    const [uploads, setuploads] = useState([])
    const [visible, setVisible] = useState(false)
    const [limit, setLimit] = useState(router.query?.limit ? parseInt(router.query?.limit) : 10)
    const [count, setCount] = useState(0)
    const [ordering, setOrdering] = useState(router.query?.ordering ?? '-id')
    const classes = useStyles()
    const data = useData()

    /**
     * Retrieve a list of all uploads from the data layer
     */
    const getuploads = () => {
        const upload = data.tlr()
        const offset = (currentPage - 1) * limit;

        trackPromise(
            upload.getAllUploads(limit, offset, ordering,)
                .then(async res => {
                    const { uploads, count } = res
                    setuploads(uploads)
                    setCount(count)

                    router.replace({
                        search: `?page=${currentPage}&limit=${limit}&ordering=${ordering}`
                    })
                })
        )
    }
    useEffect(() => {
        getuploads()

        // eslint-disable-next-line
    }, [limit, currentPage, ordering])

    /**
     * Create a new job with no template
     */
    const newUpload = () => {
        setVisible(true)
    }

    // close drawer
    const close = (upload) => {
        setVisible(false)
        getuploads()
    }






    // delete a upload
    const deleteUploads = (job) => {
        const { id } = job
        const tlr = data.tlr()

        trackPromise(
            tlr.deleteUpload(id)
                .then(() => {
                    notification.success({
                        message: "Upload deleted successfully."
                    })
                    getuploads()
                }).catch(err => {
                    notification.error({
                        message: "Error running job",
                        description: "An error occured scheduling a job. Check console for logs"
                    })

                    console.log(err)
                })
        )
    }



    // loading data
    const { promiseInProgress } = usePromiseTracker()

    return (
        <DashboardLayout
            selected="tlr"
        >
            <DashboardPage
                title="TLR Uploads"
                buttonText="Upload to TLR"
                onCtaClick={newUpload}
                ctaIcon={<PlusOutlined />}
            >


                <div className={classes.content}>
                    <UploadsTableView
                        deleteUpload={deleteUploads}
                        uploads={uploads}
                        loading={promiseInProgress}
                        count={count}
                        updateLimit={setLimit}
                        page={currentPage}
                        limit={limit}
                        setOrdering={setOrdering}
                        updatePage={setCurrentPage}
                    />
                </div>

                <AddNewUpload

                    visible={visible}

                    close={close}
                />


            </DashboardPage>
        </DashboardLayout>
    )

}

export default Uploads
